"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importColumnAliasTargetColumnNames = void 0;
var importColumnAliasTargetColumnNames;
(function (importColumnAliasTargetColumnNames) {
    importColumnAliasTargetColumnNames["FIRST_NAME"] = "firstName";
    importColumnAliasTargetColumnNames["LAST_NAME"] = "lastName";
    importColumnAliasTargetColumnNames["EMAIL"] = "email";
    importColumnAliasTargetColumnNames["MOBILE_NUMBER"] = "mobileNumber";
    importColumnAliasTargetColumnNames["LANDLINE_NUMBER"] = "landlineNumber";
    importColumnAliasTargetColumnNames["DATE_OF_BIRTH"] = "dateOfBirth";
    importColumnAliasTargetColumnNames["GENDER"] = "gender";
    importColumnAliasTargetColumnNames["EXTERNAL_ID"] = "externalId";
    importColumnAliasTargetColumnNames["ADDRESS_LINE_1"] = "addressLine1";
    importColumnAliasTargetColumnNames["ADDRESS_LINE_2"] = "addressLine2";
    importColumnAliasTargetColumnNames["POSTAL_CODE"] = "postalCode";
    importColumnAliasTargetColumnNames["CITY"] = "city";
    importColumnAliasTargetColumnNames["STATE_OR_PROVINCE"] = "stateOrProvince";
    importColumnAliasTargetColumnNames["POB"] = "pob";
    importColumnAliasTargetColumnNames["ICD_CODE"] = "icdCode";
    importColumnAliasTargetColumnNames["PATIENT_CONDITION"] = "patientCondition";
    importColumnAliasTargetColumnNames["LAST_ACR_LAB_TEST"] = "lastAcrLabTest";
    importColumnAliasTargetColumnNames["PCP_NAME"] = "pcpName";
    importColumnAliasTargetColumnNames["PCP_EMAIL"] = "pcpEmail";
    importColumnAliasTargetColumnNames["PCP_PHONE_NUMBER"] = "pcpPhoneNumber";
    importColumnAliasTargetColumnNames["PCP_FAX_NUMBER"] = "pcpFaxNumber";
    importColumnAliasTargetColumnNames["PCP_STATE_OR_PROVINCE"] = "pcpStateOrProvince";
    importColumnAliasTargetColumnNames["PCP_ADDRESS_LINE_1"] = "pcpAddressLine1";
    importColumnAliasTargetColumnNames["PCP_ADDRESS_LINE_2"] = "pcpAddressLine2";
    importColumnAliasTargetColumnNames["PCP_POSTAL_CODE"] = "pcpPostalCode";
    importColumnAliasTargetColumnNames["PCP_CITY"] = "pcpCity";
    importColumnAliasTargetColumnNames["PCP_NPI"] = "pcpNpi";
    importColumnAliasTargetColumnNames["PRESCRIBING_DOCTOR_NAME"] = "prescribingDoctorName";
    importColumnAliasTargetColumnNames["PRESCRIPTION_DATE"] = "prescriptionDate";
    importColumnAliasTargetColumnNames["PRESCRIPTION_LINK"] = "prescriptionLink";
    importColumnAliasTargetColumnNames["GP_NAME"] = "gpName";
    importColumnAliasTargetColumnNames["GP_CODE"] = "gpCode";
    importColumnAliasTargetColumnNames["SERVICE_QUALIFICATION_STARTS_AT"] = "serviceQualificationStartsAt";
    importColumnAliasTargetColumnNames["SERVICE_QUALIFICATION_ENDS_AT"] = "serviceQualificationEndsAt";
    importColumnAliasTargetColumnNames["IS_COMMUNICATION_ALLOWED"] = "isCommunicationAllowed";
})(importColumnAliasTargetColumnNames || (exports.importColumnAliasTargetColumnNames = importColumnAliasTargetColumnNames = {}));
